import JWT from "../jwt";

export default {
  state: {
    isLoggedIn: JWT.isLoggedIn(),
    pending: false
  },
  mutations: {
    AUTH_LOGIN: state => {
      state.pending = true;
    },
    AUTH_LOGIN_SUCCESS: state => {
      state.isLoggedIn = true;
      state.pending = false;
    },
    AUTH_LOGOUT: state => {
      state.isLoggedIn = false;
    }
  },
  actions: {
    login({ commit }, creds) {
      commit("AUTH_LOGIN");
      return JWT.login(creds.username, creds.password).then(() =>
        commit("AUTH_LOGIN_SUCCESS")
      );
    },
    logout({ commit }) {
      return JWT.logout().then(() => commit("AUTH_LOGOUT"));
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    userData: state => JWT.getData(),
  }
};



// WEBPACK FOOTER //
// ./src/store/auth.js